import React, { useEffect } from 'react';
import TopBar from '../Home/TopBar';
import OrderSummary from './OrderSummary';
import OrderSummaryDesktop from './OrderSummaryDesktop';
import Sidebar from './Sidebar';
import PropertyCard from './PropertyCard';
import { DetailOuterWrap, Wrapper, OuterWrapper, InnerWrapper } from './styles';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import { Order } from '../types';
import { useUserContext } from '../../context/UserContext';
import { downloadDocument, downloadOrderDocuments } from '../../components/utilities/fileUtilities';
import immer from 'immer';
import { useSearchParams } from '../../context/SearchParamsContext';

const OrderDetailsPage = () => {
  const userContext = useUserContext();
  const searchParams = useSearchParams();
  const clientId = userContext.user.clientId;
  const history = useHistory();
  const [showLoader, setShowLoader] = useState(false);
  const [searchesToDownload, setSearchesToDownload] = useState([]);
  const [order, setOrder] = useState<Order>();
  const status = order?.properties.filter(p => {
    return (
      p.searches.filter(s => {
        return s.searchStatusType === 'Completed';
      }).length > 0
    );
  });

  const { orderId } = useParams<{ orderId: string }>();
  const headerSearch = () => {
    const queryString = qs.stringify({
      open: searchParams.isTopSearchOpen ? 1 : 0,
      query: searchParams.topSearchText,
    });
    document.title = '';
    history.push(`/home?${queryString}`);
  };

  useEffect(() => {
    if (clientId !== 0) {
      getOrderDetails();
    }
  }, [userContext]);

  const getOrderDetails = async () => {
    const queryString = qs.stringify({ orderId, clientId });
    setShowLoader(true);
    const { data } = await axios.get(`/api/clientorder/getorder?${queryString}`);
    setOrder(data);
  };

  const closeDetailsSearch = () => {
    searchParams.setTopSearchText('');
    searchParams.setIsTopSearchOpen(false);
  };

  const download = async (merge: boolean) => {
    let searches = order.properties.flatMap(p => p.searches).filter((s) => searchesToDownload.includes(s.id));
    downloadOrderDocuments(order.titleNumber, merge, searches);
  };

  const downloadSda = async (orderId: number) => {
    const queryString = qs.stringify({ orderId });
    const { data } = await axios.get(`/api/clientorder/getSdaDocIds?${queryString}`);
    if (data.length > 0) {
      data.forEach(async (docId: any) => {
        await downloadDocument(docId);
      });
    }
  };
  const getPriority = () => {
    if (order?.isSuperRush) {
      return 'Super Rush';
    } else if (order?.isRush) {
      return 'Rush';
    } else return 'Regular';
  };

  const setPriority = async (priority: string) => {
    const updatedOrder = immer(order, draft => {
      if (draft != null) {
        draft.isRush = priority === 'Rush';
        draft.isSuperRush = priority === 'Super Rush';
      }
    });
    setOrder(updatedOrder);
    await axios.post(`/api/clientorder/updateorder`, { ...updatedOrder });
  };
  const sdaProperties = order?.properties
    .map(p => {
      const hasSda = p.searches.find(s => s.searchStatusType === 'SDA Requested') !== undefined;
      if (hasSda) {
        return p;
      } else {
        return null;
      }
    })
    .filter(p => p);
  return (
    <>
      {order && (
        <div>
          <TopBar
            search={headerSearch}
            searchText={searchParams.topSearchText}
            onSearchTextChange={searchParams.setTopSearchText}
            name={order.clientName}
            titleNumber={order.titleNumber}
            setSearchOpen={searchParams.setIsTopSearchOpen}
            searchOpen={searchParams.isTopSearchOpen}
            info
            closeSearch={closeDetailsSearch}
            isTitleNumber
            orderId={order.id}
          />
          <DetailOuterWrap>
            <Wrapper>
              <OrderSummary
                order={order}
                priority={getPriority()}
                download={download}
                getPriority={getPriority}
                setPriority={setPriority}
                showDownload={status.length > 0}
              />
              <OrderSummaryDesktop
                order={order}
                download={download}
                getPriority={getPriority}
                setPriority={setPriority}
                showDownload={status.length > 0}
                // uploadStatus={uploadStatus.length > 0}
                // onDownload={() => downloadSda(order.id)}
                // onUpload={() => uploadSda(order.id)}
                getOrderDetails={getOrderDetails}
                searchesToDownload={searchesToDownload}
              />
              {/* {notGrouped ? (
                <NotGrouped
                  onClick={() => setNotGrouped(false)}
                  properties={order.properties}
                />
              ) : ( */}
              <>
                <OuterWrapper>
                  <InnerWrapper>
                    {order.properties &&
                      order.properties.map((p, i) => {
                        return (
                          <PropertyCard
                            key={i}
                            addresses={p.address}
                            addressLine2={p.addressLine2}
                            section={p.section}
                            block={p.block}
                            lot={p.lot}
                            subMunicipalityType={p.subMunicipalityType}
                            municipalityType={p.municipalityType}
                            municipality={p.municipality}
                            subMunicipality={p.subMunicipality}
                            swisCode={p.swisCode}
                            county={p.county}
                            number={i}
                            searches={p.searches}
                            defaultOpen={i === 0}
                            order={order}
                            uploadStatus={sdaProperties.map(pr => pr.id).includes(p.id)}
                            onDownload={() => downloadSda(order.id)}
                            otherSdaProperties={sdaProperties.filter(sda => sda.id !== p.id)}
                            propertyId={p.id}
                            getOrderDetails={getOrderDetails}
                            searchesToDownload={searchesToDownload}
                            setSearchesToDownload={setSearchesToDownload}
                          />
                        );
                      })}
                  </InnerWrapper>
                  {order.contacts && <Sidebar contact={order.contacts} order={order} />}
                </OuterWrapper>
              </>
            </Wrapper>
          </DetailOuterWrap>
        </div>
      )}
    </>
  );
};

export default OrderDetailsPage;
